// Unsaved work across the app: dirty forms (useUnsavedChanges) + any rich-text composer with text in it.
const dirty = new Set();

export const markDirty = (key, on) => (on ? dirty.add(key) : dirty.delete(key));

export const hasUnsavedWork = () =>
  dirty.size > 0 || [...document.querySelectorAll(".ProseMirror")].some((el) => el.textContent.trim().length > 0 || el.querySelector("img"));

// Uploads in flight (multipart requests through the api client); ids survive the CSRF retry.
const uploads = new Set();
export const uploadStarted = (id) => uploads.add(id);
export const uploadEnded = (id) => uploads.delete(id);
export const uploadsInProgress = () => uploads.size > 0;
